<template>
    <div class="handle-box-search">
        <div class="fuliguan">
            <div class="status-btn">
                <span>汉服功能开启</span>
                <div style="margin-left: 10px">
                    <el-switch v-model="submit_data.status" inactive-text="" active-value="1" inactive-value="0"> </el-switch>
                </div>
            </div>
            <div v-if="submit_data.status == 1" style="margin-top: 20px">
                <div class="coupon">
                    <span>优惠券:</span>

                    <el-select
                        v-model="value_coupon_code"
                        placeholder="请选择优惠券"
                        @visible-change="couponList"
                        @change="couponChange"
                        clearable
                        style="position: relative; width: 150px; margin-left: 10px"
                    >
                        <el-option v-for="item in options_coupon_code" :key="item.value" :label="item.name" :value="item.coupon_mode_code">
                        </el-option>

                        <el-pagination
                            class="pagination"
                            layout="prev, pager, next"
                            :total="selectPages_coupon_data.count"
                            :page-size="coupon_options_data.limit"
                            @current-change="selectPages_coupon_function"
                            :current-page="coupon_options_data.page"
                        />
                    </el-select>
                </div>
               
               
            </div>
        </div>

        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center;margin-top:10px">
            <el-button type="primary" @click="onSubmitDig">保存</el-button>
        
        </div>
    </div>
</template>
<script>
var _this;


export default {
    data() {
        return {
          
            status: 0,
         
       
            value_coupon_code: '',
            options_coupon_code: [],
            selectPages_coupon_data: [],
            coupon_options_data: {
                page: 1,
                limit: 5,
                status: 1
            },

            submit_data: {
                status: 0,
            
                coupon_mode_code: ''
            },
            submit_rules: {
              
                coupon_mode_code: {
                        placeholder: '请选择优惠券',
                        rules: {
                            required: false,
                            message: '优惠券',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }

                    }
            }
        };
    },
    created() {
        _this = this;
        _this.details();
    },
    methods: {
        selectPages_coupon_function(search_data) {
            _this.coupon_options_data.page = search_data;

            _this.couponList();
        },
        couponChange(val) {
            _this.submit_data.coupon_mode_code = val;
        },
        couponList() {
            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    _this.selectPages_coupon_data = res;
                    _this.options_coupon_code = res.data;
                })
                .catch((err) => {});
        },
        
        // 提交
        onSubmitDig() {
          
            console.log(_this.submit_data.status,'_this.submit_data.status');
            if (_this.submit_data.status == "1") {
                _this.submit_rules.coupon_mode_code.rules.required = true;
            } else {
                _this.submit_rules.coupon_mode_code.rules.required = false;
            }
            _this.$post('/hanfu/edit', _this.submit_data, _this.submit_rules).then((res) => {
          
                _this.$message.success('操作成功！');
                _this.details();
            });
        },

        details() {
            _this.$post('/hanfu/details').then((res) => {
                _this.submit_data.status = res.data.status;
                _this.submit_data.coupon_mode_code = res.data.coupon_mode_code;
                _this.value_coupon_code = res.data.coupon_mode_name;
                
            });
        }
    }
};
</script>
<style scoped>

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 220px;
    height: 220px;
    display: block;
}

.avatar-uploader {
    width: 220px;
    height: 220px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}
.handle-box-search {
    background-color: #fff !important;
}
.status-btn {
    width: 220px;
    display: flex;
  
    margin-top: 10px;
 
}
.fuliguan {
    width: 50%;
    margin: 0 auto;
    color: black;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
 
    
   
}
.coupon {
    width: 100%;

}
.erWei {
    width: 100%;
    margin-top: 20px;

}

</style>